import { tableUpdate } from "helpers/reducers";
import moment from "moment";
import { AnyAction } from "redux";
import { TABLE_UPDATE } from "./types";
import { omit } from "lodash";

interface IDashboard {
    id: string;
    filters: any;
    periodType: string;
}
function DashboardReducer(
    state: IDashboard = {
        id: "Dashboard",
        filters: {
            created_at_period_filter: {
                after: moment().local().format("YYYY-MM-DD"),
                before: moment().local().format("YYYY-MM-DD"),
            },
        },
        periodType: "today",
    },
    action: AnyAction
) {
    switch (action.type) {
        case TABLE_UPDATE:
            return {
                ...tableUpdate(state, omit(action, "periodType")),
                periodType: action.data?.periodType || state.periodType,
            };

        default:
            return state;
    }
}

export default DashboardReducer;
